import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    refresh: false,
};

export const branchLocationSlice = createSlice({
    name: 'branchLocation',
    initialState,
    reducers: {
        setRefresh: (state, action) => {
            state.refresh = action.payload.refresh;
        }
    },
});

export const { setRefresh } = branchLocationSlice.actions;
export default branchLocationSlice.reducer;
